<template>
  404 Page Not Found
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "pagenotfound",
  data: () => ({}),
  methods: {}
};
</script>
